import { render, staticRenderFns } from "./St21Cn2061ReportYear.vue?vue&type=template&id=e13f2f5c&scoped=true&"
import script from "./St21Cn2061ReportYear.vue?vue&type=script&lang=js&"
export * from "./St21Cn2061ReportYear.vue?vue&type=script&lang=js&"
import style0 from "./St21Cn2061ReportYear.vue?vue&type=style&index=0&id=e13f2f5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13f2f5c",
  null
  
)

export default component.exports